__webpack_require__.p = "/poke-memory/";